import $ from 'jquery';
import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive(".come-lavoriamo", {existing: true}, function (){

  gsap.to(".section-title-come-lavoriamo-first-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".section-title-come-lavoriamo-first-line",
      toggleClass: "animate",
      
    }
  })
  gsap.to(".section-title-come-lavoriamo-second-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".section-title-come-lavoriamo-second-line",
      toggleClass: "animate",
      
    }
  })
  gsap.to(".section-title-come-lavoriamo-third-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".section-title-come-lavoriamo-third-line",
      toggleClass: "animate",
      
    }
  })
  gsap.to(".section-title-come-lavoriamo-fourth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".section-title-come-lavoriamo-fourth-line",
      toggleClass: "animate",
      
    }
  })

  gsap.to(".img-container-come-lavoriamo img", {
    duration: 2,
    scale: 1,
    scrollTrigger: {
      trigger: ".img-container-come-lavoriamo img",
      scrub: 1
    }
  })

  gsap.to(".floating-text p", {
    x: 0,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".floating-text",
      toggleActions: "restart none resume none",
    }
  })

  gsap.to(".show-mobile p", {
    x: 0,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".show-mobile",
      toggleActions: "restart none resume none",
    }
  })

  gsap.to(".text-curiamo p", {
    x: 0,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".come-lavoriamo-below",
      toggleActions: "restart none resume none",
    }
  })

  gsap.to(".img-container-below", {
    x: 0,
    opacity: 1,
    duration: 1.2,
    scrollTrigger: {
      trigger: ".come-lavoriamo-below",
      toggleActions: "restart none resume none",
    }
  })


})